import React from "react";
import styled from "styled-components";
import Github from "../img/icons/github-white.svg";
import LinkedIn from "../img/icons/LI-In-Bug.png";
import Email from "../img/icons/mail-white.svg";
const Footer = () => {
  return (
    <FooterWrapper>
      <Bar>
        <a href="mailto:genechanemail@gmail.com" target="_blank">
          <Image src={Email} />
        </a>
        <a href="https://github.com/genechan" target="_blank">
          <Image src={Github} />
        </a>
        <a href="https://www.linkedin.com/in/gene-chan/" target="_blank">
          <Image src={LinkedIn} />
        </a>
      </Bar>
      <Copy>Thanks for visiting!</Copy>
    </FooterWrapper>
  );
};
const FooterWrapper = styled.section`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 100;
`;
const Bar = styled.div`
  width: 100%;
  height: 2.5em;
  padding: 0.5em 0;
  text-align: left;
  background-color: var(--wet-asphalt);
  box-shadow: 0px 1px 9px 1px var(--asbestos);
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    padding: 3em;
    height: 6em;
  }
`;
const Image = styled.img`
  width: 2.5em;
  height: 2.5em;
  margin: 0 1em;
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    width: 6em;
    height: 6em;
    margin: 0 2em;
  }
`;
const Copy = styled.div`
    width: 100%;
    height 3em;
    background-color: var(--clouds);
    padding: 1em 0 0;
  @media only screen and (min-device-width: 320px) and (max-device-width: 479px) {
    font-size: x-large;
    font-weight: bolder;
  }
`;
export default Footer;
